// extracted by mini-css-extract-plugin
export default {"funnelPage":"Funnel_funnelPage__c9tDc"};